define([
    'text!./templates/basler-list-item-selector-term.html',
], (templateStr) => {

    const directive = function () {
        return {
            restrict: 'E',
            template: templateStr,
            scope: {
                term: '=',
                disabled: '=?',
            },
        };
    };
    directive.$inject = [];

    return directive;
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerListItemSelectorTerm.js